<p>search-mobile works!</p>
<form>
    <a href="#" class="search-btn">
        <!-- <img src="../../../assets/images/research.svg" alt="search button" width="14" height="181"
            id="mobile-search-icon"> -->
        <span class="material-icons-outlined" id="mobile-search-icon">
            search
        </span>

    </a>

    <div class="search_section">
        <input type="text" class="searchbox" autocomplete="off" name="ss" id="ss" value="{{keyword}}"
            (blur)="hideSuggestionDivMobile()" type="text" (click)="openSuggestionBoxMobile($event)"
            (keyup)="searchKeywordMobile($event)" placeholder="I'm searching for">
        <span class="close_search" (click)="hideSuggestionDivMobile()"></span>
 
    </div>
    <div class="suggestion-box-mobile" id="suggestion-box-mobile">
        <ng-container *ngFor="let searchdata of data;">
            <a class="pointer" (mousedown)="setKeywordMobile(searchdata)">
                <!-- <div>{{searchdata.keyword}}</div> -->
            </a>
        </ng-container>
        <div *ngIf="notFoundTemplate">
            <a>Not Found</a>
        </div>
    </div>


</form>